import type { ZodSchema } from 'zod';

export const ERROR_LAYER = {
  API: 'API',
  SERVICE: 'SERVICE',
} as const;

export const API_ERROR_TYPE = {
  REQUEST_ERROR: 'REQUEST_ERROR',
  RESPONSE_ERROR: 'RESPONSE_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export const SERVICE_ERROR_TYPE = {
  REQUEST_ERROR: 'REQUEST_ERROR',
  RESPONSE_ERROR: 'RESPONSE_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

type ERROR_LAYER = (typeof ERROR_LAYER)[keyof typeof ERROR_LAYER];
type API_ERROR = (typeof API_ERROR_TYPE)[keyof typeof API_ERROR_TYPE];
type SERVICE_ERROR = (typeof SERVICE_ERROR_TYPE)[keyof typeof SERVICE_ERROR_TYPE];
type CUSTOM_ERRPR = string;
type ERROR_TYPE = API_ERROR | SERVICE_ERROR | CUSTOM_ERRPR;

export type ErrorLayer = ERROR_LAYER;
export type ErrorType = ERROR_TYPE;

export interface ErrorContext<S extends ZodSchema> {
  layer: ErrorLayer;
  type: ErrorType;
  schema: S;
}

export const normalizeErrorMessage = <S extends ZodSchema>(
  context: ErrorContext<S>,
  message: string,
) => {
  const schemaName = context.schema.description || 'UnknownSchema';
  return `[${context.layer}/${context.type}/${schemaName}]: ${message}`;
};
